import Model from "../Model";

class KpiRepresentantegraphsuser extends Model{

    buildUrl ({ param }) {
        return ['kpiemployee/getdimensionbyuserregion', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiRepresentantegraphsuser;